import { MarketPeriods } from "app/utils/const";
import { api } from "../helpers/apiHelper";
const API_POSITION_MATRIX = "/position-matrices";

/**
 * fetch position matrix list
 */
export const fetchPositionMatrices = (period: string): any => {
  const url = API_POSITION_MATRIX;
  const params = {
    period: period ? period : MarketPeriods.FULL_EVENT,
  };
  return api.get(url, {
    params: params,
  });
};

/**
 * fetch position matrix by eventId
 */
export const fetchPositionMatrix = (eventId: number, period: string): any => {
  const url = API_POSITION_MATRIX + `/${eventId}`;
  const params = {
    period: period ? period : MarketPeriods.FULL_EVENT,
  };
  return api.get(url, {
    params: params,
  });
};
